import React, { useContext, useEffect, useState } from "react";
import ReactTable from "react-table";
import * as notify from "../../shared/notify";

import { ButtonInput, ButtonSelect } from "../form-inputs/inputs";
import { useInput } from "../../shared/hooks/form-fields";
import { addBinToShipment, getLocations } from "./lib/binData";
import { ShipmentContext } from "./contexts";
import { BIN_COLUMNS } from "./lib/constants";
import { SHIPMENT_TYPE_MAP } from "../shipments/lib/constants";

const ShipmentBins = () => {
    const { bins, shipmentData, updateBins } = useContext(ShipmentContext);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [locations, setLocations] = useState([]);
    const locationSelect = useInput("");
    const binInput = useInput("");

    useEffect(() => {
        getLocationList();
    }, []);

    const getLocationList = async () => {
        const locationList = await getLocations();

        if (!locationList) {
            return;
        }

        setLocations(locationList);
        locationSelect.setValue(locationList[0].value);
    };

    const addBinByLocation = async () => {
        if (!locationSelect.value) {
            notify.error("Please select a location");

            return;
        }

        setIsSubmitting(true);

        const addedBin = await addBinToShipment(locationSelect.value);

        if (!addedBin) {
            setIsSubmitting(false);
        }

        const bin = addedBin.trackingNumber;
        const newBins = [...bins, bin];
        setIsSubmitting(false);
        updateBins(newBins);
        notify.success("Saved!");
    };

    const addBinManually = (name, value) => {
        if (!binInput.value) {
            notify.error("Please enter a value");

            return;
        }

        const newBins = [...bins, binInput.value];
        updateBins(newBins);
        notify.success("Saved!");
        binInput.reset();
    };

    const binIds = bins.map((id) => {
        return { id };
    });

    if (SHIPMENT_TYPE_MAP[shipmentData.shipmentType].isDigital) {
        return null;
    }

    return (
        <fieldset>
            <legend>Bins For This Shipment</legend>

            <div className="row">
                <div className="column -span4">
                    <h3>Bin Details</h3>
                    <div className="input-group">
                        <ButtonSelect
                            required={!SHIPMENT_TYPE_MAP[shipmentData.shipmentType].isDigital && binIds.length === 0}
                            name="locationBinLookup"
                            label="Location"
                            excludeSelect={true}
                            {...locationSelect.bind}
                            options={locations}
                            buttonClick={addBinByLocation}
                            disable={isSubmitting}
                        />
                    </div>
                    <p className="txt-center">-or-</p>
                    <div className="input-group">
                        <ButtonInput
                            required={!SHIPMENT_TYPE_MAP[shipmentData.shipmentType].isDigital && binIds.length === 0}
                            name="binToShipment"
                            label="Bin"
                            {...binInput.bind}
                            buttonClick={addBinManually}
                            disable={isSubmitting}
                        />
                    </div>
                </div>
                <div className="column -span8">
                    <ReactTable
                        data={binIds}
                        columns={BIN_COLUMNS}
                        minRows="5"
                        showPagination={false}
                    />
                </div>
            </div>
        </fieldset>
    );
};

export default ShipmentBins;
